module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image16c.b6353c46.jpg";